import { render, staticRenderFns } from "./ShapeOr.vue?vue&type=template&id=0c5b1689&"
import script from "./ShapeOr.vue?vue&type=script&lang=js&"
export * from "./ShapeOr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports